import axios from "axios";

const BASE = process.env.REACT_APP_BACKEND_URL;
export const API = `${BASE}/api`;

// Direct Stripe Payment Link for the Firm Plan ($199/mo, card only).
// client_reference_id ties the checkout back to the consultant so the
// webhook can unlock the right account; prefilled_email is a fallback match.
export const FIRM_PLAN_PAYMENT_LINK =
    process.env.REACT_APP_STRIPE_PAYMENT_LINK || "https://buy.stripe.com/fZu4gy24gdKI1eOgFlgjC04";

export function firmPlanPaymentUrl(user) {
    const params = new URLSearchParams();
    if (user?.id) params.set("client_reference_id", user.id);
    if (user?.email) params.set("prefilled_email", user.email);
    const qs = params.toString();
    return qs ? `${FIRM_PLAN_PAYMENT_LINK}?${qs}` : FIRM_PLAN_PAYMENT_LINK;
}

// Session auth rides in a Secure httpOnly cookie set by the backend —
// nothing is ever stored in localStorage, so XSS can't steal the session.
export const api = axios.create({ baseURL: API, withCredentials: true });

export function formatApiError(detail) {
    if (detail == null) return "Something went wrong. Please try again.";
    if (typeof detail === "string") return detail;
    if (Array.isArray(detail))
        return detail
            .map((e) => (e && typeof e.msg === "string" ? e.msg : JSON.stringify(e)))
            .filter(Boolean)
            .join(" ");
    if (detail && typeof detail.msg === "string") return detail.msg;
    if (detail && typeof detail.detail === "string") return detail.detail;
    return String(detail);
}

// --- Lightweight in-house analytics ---
// Never throws; fire-and-forget so it never blocks a CTA click.
export function trackEvent(event, extras = {}) {
    try {
        const body = JSON.stringify({
            event,
            location: extras.location,
            label: extras.label,
            props: extras.props,
        });
        if (navigator.sendBeacon) {
            const blob = new Blob([body], { type: "application/json" });
            navigator.sendBeacon(`${API}/analytics/events`, blob);
            return;
        }
        fetch(`${API}/analytics/events`, {
            method: "POST",
            headers: { "Content-Type": "application/json" },
            credentials: "include",
            body,
            keepalive: true,
        }).catch(() => {});
    } catch {
        // analytics must never break the app
    }
}

export function roleHome(role) {
    if (role === "client") return "/portal";
    if (role === "auditor") return "/auditor";
    return "/dashboard";
}
